import type { ModalActionHandler } from './modalActionTypes';
import { unassignJob } from '../map/settlement';
import { getSettlement } from './settlementActionUtils';

export const fireSawmillerAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement || settlement.jobs.sawmillers <= 0) return false;
    return unassignJob(settlement, 'sawmillers');
};
